<template>
  <Wizzard
    title="Add Private Security or Other"
    name="Private Security or Other"
    :modal
    :preset
    :steps="STEPS_LIST"
    :transaction-type="TRANSACTION_TYPE"
    :asset-classes-list="ASSET_CLASSES_LIST"
    :investment-strategies-list="INVESTMENT_STRATEGIES_LIST"
    :handle-before-save-asset
  />
</template>

<script setup lang="ts">
import { provide } from 'vue'

import { AssetClass, ModalClass } from '@types'
import { InputWizardPreset } from '../utils/types'
import {
  ASSET_CLASSES_LIST,
  ASSET_TYPE_EXCLUDES,
  INVESTMENT_STRATEGIES_LIST,
  STEPS_LIST,
  TRANSACTION_TYPE,
} from './utils/const'

import { addPostfixToAssetTicker } from '../utils/helpers'

import { useAssetsBunchStore } from '@/store/assets/bunch'

import Wizzard from '../components/Wizzard.vue'

type Props = {
  modal: ModalClass<any>
  preset?: InputWizardPreset
}

defineProps<Props>()

provide('assetExcludes', ASSET_TYPE_EXCLUDES)

provide('assetDateLabel', 'Date of Investment')
provide('amountLabel', 'Cost of Investment')
provide('valuePlaceholder', 'Investment value')
provide('valueLabel', 'Valuation')

const assetsBunchStore = useAssetsBunchStore()

const handleBeforeSaveAsset = async (
  accountId: string | null,
  asset: AssetClass,
) => {
  if (!accountId) return
  const account = assetsBunchStore.getElementById(accountId)
  if (!account) return
  addPostfixToAssetTicker(asset, account)
}
</script>
